import { useLanguage } from "@/lib/i18n";
import { blogScanContent } from "./content";

export function BlogScanIntro() {
  const { language } = useLanguage();
  const c = blogScanContent[language].intro;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 pt-10 pb-8">
      <div className="space-y-6">
        <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
          {c.p1}
        </p>

        <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
          {c.p2}
        </p>

        <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-5">
          {c.howItWorksTitle}
        </h2>

        <p className="font-['Source_Serif_4'] text-lg md:text-xl leading-relaxed text-foreground/90 font-medium mb-5">
          {c.howItWorksIntro}
        </p>

        <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
          {c.howItWorksP1}
        </p>

        <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
          {c.howItWorksP2}
        </p>
      </div>
    </section>
  );
}
